/**
 * Camere Page - Page Shell
 * Lista camere
 */

import { CamereList } from "@/features/strutture";

export default function Camere() {
  return <CamereList />;
}
